const PERCENTAGE_ROWS = [
  // 'Total Rev / Total Assets',
  'Operating Profit / Total Rev %',
  'FCF / Total Debt',
];

export default PERCENTAGE_ROWS;
